import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faPhoneVolume,
  faKeyboard,
  faMicrophone,
  faHeadset,
  faPhoneSlash,
} from "@fortawesome/free-solid-svg-icons";

const steps = [
  {
    id: 1,
    title: "Call Initiation",
    icon: faPhoneVolume,
    heading: "Call Initiation",
    description: `A customer calls a business and is greeted by the IVR system, which plays a recorded greeting and presents options through voice prompts.`,
    side: "right",
  },
  {
    id: 2,
    title: "Input from Customer",
    icon: faKeyboard,
    heading: "Input from Customer",
    description: `The caller interacts with the system by pressing keys on their phone (Dual-Tone Multi-Frequency or DTMF) or speaking their choices if speech recognition is enabled.`,
    side: "left",
  },
  {
    id: 3,
    title: "Processing Input",
    icon: faMicrophone,
    heading: "Processing Input",
    description: `The IVR system processes the input (whether keypad selection or voice command) and determines the appropriate action, such as routing the call to the relevant department, providing requested information, or directing the customer to a live agent if needed.`,
    side: "right",
  },
  {
    id: 4,
    title: "Completion or Further Interaction",
    icon: faHeadset,
    heading: "Completion or Further Interaction",
    description: `The system either completes the transaction or continues interacting with the customer to gather further details. If necessary, the call is transferred to a live representative.`,

    side: "left",
  },
  {
    id: 5,
    title: "End of Call",
    icon: faPhoneSlash,
    heading: "End of Call",
    description: `Once the interaction is completed, the IVR system closes the call, either providing a summary of the service (e.g., a transaction confirmation) or ending with a message thanking the customer for their call.`,
    side: "right",
  },
];
const IvrWorks = () => {
  return (
    <div className="bg-blue-50">
      <section className="relative max-w-6xl mx-auto py-16 items-center text-main1">
        <h2 className="text-4xl font-bold text-center mb-4">How IVR Works?</h2>
        <p className="text-center mb-10 text-gray-600">
          A step-by-step overview of how our IVR system handles incoming calls
          with efficiency and intelligence.
        </p>

        <div className="relative">
          {/* Vertical Line (Hidden on Mobile) */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-cyan-500 via-green-500 to-pink-500"></div>

          <div className="space-y-5">
            {steps.map((step, idx) => (
              <div
                key={idx}
                className={`relative flex ${
                  step.side === "left" ? "justify-start" : "justify-end"
                } md:flex`}
              >
                {/* Dot (Hidden on Mobile) */}
                <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2">
                  <span className="w-6 h-6 bg-black border-4 border-cyan-500 rounded-full block"></span>
                </div>

                {/* Card */}
                <div
                  className={`w-full max-w-md p-6 md:mx-0 mx-3 rounded-lg bg-white shadow-xl ${
                    step.side === "left"
                      ? "md:ml-20 md:text-left text-center"
                      : "md:mr-20 md:text-left text-center"
                  } mx-auto`}
                >
                  {/* Icon and Heading */}
                  <div className="flex items-center gap-3 justify-center md:justify-start mb-2">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-cyan-100">
                      <FontAwesomeIcon
                        icon={step.icon}
                        className="text-cyan-600 text-lg"
                      />
                    </div>
                    <h3 className="text-main font-semibold text-[20px]">
                      {step.heading}
                    </h3>
                  </div>

                  {/* Description */}
                  <div className="mt-2">
                    <p className="text-gray-800 text-[15px] ">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default IvrWorks;

//   const steps = [
//     {
//       id: 1,
//       title: "Call Initiation",
//       icon: faPhoneVolume,
//       heading: "Call Initiation",
//       description: `A customer calls a business and is greeted by the IVR system, which plays a recorded greeting and presents options through voice prompts.`,
//     },
//     {
//       id: 2,
//       title: "Input from Customer",
//       icon: faKeyboard,
//       heading: "Input from Customer",
//       description: `The caller interacts with the system by pressing keys on their phone (Dual-Tone Multi-Frequency or DTMF) or speaking their choices if speech recognition is enabled.`,
//     },
//     {
//       id: 3,
//       title: "Processing Input",
//       icon: faMicrophone,
//       heading: "Processing Input",
//       description: `The IVR system processes the input (whether keypad selection or voice command) and determines the appropriate action, such as routing the call to the relevant department, providing requested information, or directing the customer to a live agent if needed.`,
//     },
//     {
//       id: 4,
//       title: "Completion or Further Interaction",
//       icon: faHeadset,
//       heading: "Completion or Further Interaction",
//       description: `The system either completes the transaction or continues interacting with the customer to gather further details. If necessary, the call is transferred to a live representative.`,
//     },
//     {
//       id: 5,
//       title: "End of Call",
//       icon: faPhoneSlash,
//       heading: "End of Call",
//       description: `Once the interaction is completed, the IVR system closes the call, either providing a summary of the service (e.g., a transaction confirmation) or ending with a message thanking the customer for their call.`,
//     },
//   ];
//   const [activeStep, setActiveStep] = useState(steps[0]);

//  <div className="py-16 bg-secondaryBg px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-10">
//           <h2 className="text-3xl md:text-4xl font-bold text-main mb-2">
//             How IVR Works?
//           </h2>
//           <p className="text-gray-500 max-w-2xl mx-auto">
//             A step-by-step overview of how our IVR system handles incoming calls
//             with efficiency and intelligence.
//           </p>
//         </div>

//         <div className="flex flex-col md:flex-row gap-8 max-w-7xl mx-auto">
//           {/* Left Sidebar */}
//           <div className="flex flex-col space-y-1 w-full md:w-1/3">
//             {steps.map((step) => (
//               <button
//                 key={step.id}
//                 onClick={() => setActiveStep(step)}
//                 className={`flex items-center space-x-4 text-left px-5 py-4 rounded-md border transition-all duration-300 ${
//                   activeStep.id === step.id
//                     ? "bg-blue-100 border-red-100 text-gray-800"
//                     : "bg-gray-50 border-gray-200 hover:bg-gray-100"
//                 }`}
//               >
//                 <FontAwesomeIcon icon={step.icon} size="lg" />
//                 <span className="text-base font-medium">{step.title}</span>
//               </button>
//             ))}
//           </div>
//           {/* Right Content */}
//           <div className="w-full md:w-2/3 bg-gray-50 p-6 rounded-lg shadow-md">
//             <h3 className="text-2xl font-semibold text-main mb-4">
//               {activeStep.heading}
//             </h3>
//             <p className="text-gray-600 leading-relaxed whitespace-pre-line">
//               {activeStep.description}
//             </p>
//           </div>
//         </div>
//       </div>
